import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Box } from '@withjoy/joykit';
import { DashboardChecklist } from '@apps/admin/routes/DashboardPreview/components/DashboardChecklist';
import { pxToRem } from '@withjoy/joykit/theme';
import './MobileDrawer.css';
import { withWindow } from '@shared/utils/withWindow';

export const MobileContent: React.FC<{ eventHandle: string; eventId: string }> = ({ eventHandle, eventId }) => {
  const drawerContainerRef = useRef<HTMLDivElement | null>(null);

  const [hasScrolledPastTopPadding, setHasScrolledPastTopPadding] = useState(false);

  useEffect(() => {
    const currentRef = drawerContainerRef.current;

    if (!currentRef) {
      return;
    }

    const handleScroll = () => {
      const topPadding = window.innerHeight * 0.25; // 25vh

      const hasScrolledPastTopPadding = drawerContainerRef.current!.scrollTop > topPadding;
      setHasScrolledPastTopPadding(hasScrolledPastTopPadding);
    };

    currentRef.addEventListener('scroll', handleScroll);

    return () => {
      currentRef.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const bodyTag = useMemo(() => {
    return withWindow(global => {
      return global.document.getElementsByTagName('body')[0];
    }, null);
  }, []);

  useEffect(() => {
    if (!bodyTag) {
      return;
    }

    bodyTag.classList.add('dashboard-with-bottom-drawer');

    () => {
      bodyTag.classList.remove('dashboard-with-bottom-drawer');
    };
  }, [bodyTag]);

  return (
    <Box position={'fixed'} bottom={0} left={0} right={0} zIndex={10} maxHeight={'100vh'} paddingTop={'20vh'} overflowY={'auto'} ref={drawerContainerRef}>
      <Box
        backgroundColor={'white'}
        borderTopLeftRadius={pxToRem(32)}
        borderTopRightRadius={pxToRem(32)}
        overflow={'hidden'}
        boxShadow={'0px 30px 60px -12px rgba(45, 41, 37, 0.8), 0px 18px 36px -18px rgba(0, 0, 0, 0.8)'}
      >
        <DashboardChecklist eventHandle={eventHandle} eventId={eventId} showCloseButton={hasScrolledPastTopPadding} />
      </Box>
    </Box>
  );
};
